import SwiperCore, { Keyboard, Navigation } from 'swiper';
import Swiper from 'swiper';

export function exampleSlider() {
  const $slider = $('.second-example-slider');
  if (!$slider || $slider.length === 0) return;

  SwiperCore.use([Navigation, Keyboard]);

  const swiper = new Swiper('.second-example-slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.second-example-slider-next',
      prevEl: '.second-example-slider-prev',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
}
